export default {
  header: 'Menu',
  tabs: {
    menu: 'Menu',
    modifier_groups: 'Modificadores',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o menu. Por favor, atualize e tente novamente',
  },
};
